import { Button, Card, Dialog,DialogTitle,Zoom,Grid, CardContent, Typography, DialogContent, CardMedia, useTheme, useMediaQuery } from "@mui/material";
import React, { use, useState } from "react";
import { motion } from "framer-motion";

const Works = () =>{
    // レスポンシブの設定
    const theme = useTheme();
    const isMobile = useMediaQuery(theme.breakpoints.down('sm'));

    const [openWorks, setOpenWorks] = useState(false);
    // スタイルの定義
    const hButtonStyle = {color:"white",fontSize:16,fontWeight:"bold"};
    const dButtonStyle = {width:80, height:40, backgroundColor: "white", color: "gray", fontSize:16};
    const imgLayout = { width: isMobile? '60%':'50%', height:'60%', marginLeft: isMobile?'auto':'5%' , marginRight: isMobile?'auto':'5%'};
    // タイトルと内容の定義
    const intro = "#これまでの個人活動";
    const ch1 = "#決済機能付き料理店向けSPA";
    const ch2 = "#自作web(前述のSPAなど)を公開するクラウド環境をGCPで構築(無料アカウントのため、パフォーマンス低)"
    const ch3= "#JWTを拡張したカスタム認証システムの作成(以下の構成を参考にカスタムトークンフィルターを拡張)"

    // モーションcssのカプセル化
    const initialProps = { scaleX: 0, scaleY: 0.001, opacity: 1, backgroundColor: 'gray' };
    const animationProps = [
        {scaleX: 1,backgroundColor: 'gray',transition: { duration: 0.5, ease: 'easeInOut' }},
        {scaleY: 1,opacity: 1,transition: { duration: 0.1, ease: 'easeInOut', delay: 0.5 }}
    ];
    const exitProps = { scaleY: 0, opacity: 1 };
    return (
        <div>
            <Button style={hButtonStyle} onClick={() => setOpenWorks(true)}>
                Works
            </Button>
                <Dialog 
                fullScreen
                open = {openWorks}
                disableScrollLock = {true}
                TransitionComponent={Zoom}
                slotProps={{
                    paper:{
                        style: {
                        backgroundColor: "gray",
                        transformOrigin: 'center',
                        overflow: 'hidden',
                        },
                        component:motion.div,
                        initial:initialProps,
                        animate: animationProps,
                        exit:exitProps
                    }
                }}>
                <Card className="muiCard"  sx={{boxShadow:0, background:'gray',overflow:'auto'}}>
                    <DialogTitle>
                    <h3>Individual Works</h3> 
                    </DialogTitle>
                    
                    <Button className='dButton'
                        onClick={() =>  setOpenWorks(false)}
                        style={dButtonStyle}>
                        close
                    </Button>
                    <div className="space"/>
                    <DialogContent>
                        <h4 className='subTitle'>{intro}</h4>
                        <div className="space"/>

                        <h4 className='subTitle'>{ch1}</h4>
                        <div className="space"/>
                        <CardMedia
                        sx={imgLayout}
                        component="img"
                        image="/image/JisakuSPA.png"
                        />
                        
                        <div className="space"/>
                        <h4 className='subTitle'>{ch2}</h4>
                        <div className="space"/>
                        <CardMedia
                        sx={imgLayout}
                        component="img"
                        image="/image/Architect.png"
                        />
                        

                        <div className="space"/>
                        <h4 className='subTitle'>{ch3}</h4>
                        <div className="space"/>
                        <CardMedia
                        sx={imgLayout}
                        component="img"
                        image="/image/Security.png"
                        />
                        <div className="space"/>
                        <h4 className='subTitle'>#このサイト</h4>
                        <CardMedia
                        sx={imgLayout}
                        component="img"
                        image="/image/myWeb.png"
                        />
                    </DialogContent>
 
                </Card>
            </Dialog>
        </div>
    );
};
export default Works;